// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-bw-input.bw-input-error input{border-bottom:1px solid #7e1f89}.bw-bw-input input{border:0;border-bottom:1px solid #0c0243}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bw-input": "bw-bw-input",
	"input-error": "bw-input-error"
};
module.exports = ___CSS_LOADER_EXPORT___;
